import React, { useContext } from 'react';
import { Row, Col, Input, Typography, Button, Table, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import locale from 'antd/es/locale/pt_BR';

import { useAbaCongelamento } from './useAbaCongelamento';
import { cardInputCNPJ } from './GridStyle';
import { GlobalContext } from '../../../../contexts/globalContext';
import './style.css'

import CertidoesImg from "../../../../assets/imagens/imagem_certidoes.png";

const { Text } = Typography;

export const AbaCongelamento: React.FC = () => {

    const {
        onChangeInputCNPJ,
        valueCNPJ,
        onClickGerarCertidoes,
        onClickGerarCertidoesFINEP,
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        visibleModal,
        clickCancelModal,
        loadingCertidoesCongelamnetoModal,
        refContagemDoFiltroCertidoesCongelamnetoModal,
        dadosTabelaStateCertidoesCongelamnetoModal,
        columnsCertidoesCongelamnetoModal,
        refLineTableClikedOpenModal,
        handleClickDownloadAllFileZIP,
        loading,
        errorCNPJ,
        isCertidoesModalVisible,
        handleCloseCertidoesModal,
        handleOpenCertidoesModal,
    } = useAbaCongelamento();

    const { theme } = useContext(GlobalContext);

    return (
        <>
            <Row
                style={{
                    alignItems: errorCNPJ ? 'center' : undefined
                }}
            >
                <Col
                    {...cardInputCNPJ}
                    style={{
                        paddingRight: 5,
                        paddingTop: 5
                    }}
                >
                    <Text>CNPJ:</Text>
                    <Input
                        // size='large'
                        // className='inputsLimitesETaxas'
                        placeholder="CNPJ"
                        onChange={(e) => onChangeInputCNPJ(e)}
                        value={valueCNPJ}
                        // readOnly={true}
                        // prefix={
                        //     <RiFileList2Line color='#848484' size={'1.1rem'} />
                        // }
                        disabled={loading}
                        status={errorCNPJ ? 'error' : undefined}
                    // readOnly={readonlyCNPJ}
                    />
                    {errorCNPJ && <Text style={{ color: 'red' }}>CNPJ inválido</Text>}
                </Col>
                <Col
                    style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        marginRight: 5,
                    }}
                >
                    <Button
                        type="link"
                        onClick={handleOpenCertidoesModal}
                        style={{
                            padding: "4px 8px"
                        }}
                    >
                        <InfoCircleOutlined
                            style={{
                                fontSize: '1.5rem',
                                color: theme === 'light' ? '#000000d9' : '#fff'
                            }}
                        />
                    </Button>
                </Col>
                <Col
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        alignItems: 'flex-end',
                        paddingTop: 5
                    }}
                >
                    <Button
                        type="primary"
                        style={{
                            marginRight: 5,
                        }}
                        disabled={!(valueCNPJ && valueCNPJ?.length > 17) || errorCNPJ}
                        onClick={onClickGerarCertidoes}
                        loading={loading}
                    >
                        Certidões
                    </Button>
                </Col>
                <Col
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        alignItems: 'flex-end',
                        paddingTop: 5
                    }}
                >
                    <Button
                        type="primary"
                        style={{
                            marginRight: 5,
                        }}
                        disabled={!(valueCNPJ && valueCNPJ?.length > 17) || errorCNPJ}
                        onClick={onClickGerarCertidoesFINEP}
                        className="CertidoesCongelamento_BotaoVerde_edfrgjkfbrgqrepiujhnbw"
                        loading={loading}
                    >
                        Certidões Finep/BNDES
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        style={{
                            marginTop: 15
                        }}
                        rowKey={(record) => record.id}
                        loading={loading}
                        // onRow={(record, rowIndex) => {
                        //     return {
                        //         onClick: event => { onclickTable(record, rowIndex) }, // click row
                        //         onDoubleClick: event => { }, // double click row
                        //         onContextMenu: event => { }, // right button click row
                        //         onMouseEnter: event => { }, // mouse enter row
                        //         onMouseLeave: event => { }, // mouse leave row
                        //     };
                        // }}
                        // rowSelection={rowSelection}
                        columns={columns} dataSource={dadosTabelaState}
                        scroll={{ x: 650 }}
                        onChange={
                            (pagination, filters, sorter, extra) => {
                                refContagemDoFiltro.current = extra.currentDataSource
                            }
                        }
                        title={(registros) => {
                            return (
                                <div
                                    style={{
                                        backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                        padding: 10,
                                        margin: -8,
                                        marginBottom: 0.5
                                    }}
                                >
                                    <Text>
                                        {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                            dadosTabelaState.length :
                                            refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                    </Text>
                                </div>
                            )
                        }}
                        footer={(registros) => {
                            return (
                                <div
                                    style={{
                                        textAlign: 'end'
                                    }}
                                >
                                    <Text>
                                        {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                            dadosTabelaState.length :
                                            refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                    </Text>
                                </div>
                            )
                        }}
                        size="small"
                        pagination={{
                            locale: { items_per_page: '' },
                            showSizeChanger: false,
                            defaultPageSize: 100,
                            // position: ['topRight', 'bottomRight'],
                            position: [],
                            pageSizeOptions: ['10', '20', '50', '100']
                        }}
                        locale={locale.Table}
                    />
                </Col>
            </Row>
            <Modal
                title="Certidões Congelamento"
                visible={visibleModal}
                onOk={clickCancelModal}
                onCancel={clickCancelModal}
                style={{
                    top: 20
                }}
                width={800}
                destroyOnClose
                // className="modalDadasLimite_kaevdkfaed"
                footer={[
                    <Button
                        key="back"
                        onClick={clickCancelModal}
                        loading={loadingCertidoesCongelamnetoModal}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={clickCancelModal}
                        loading={loadingCertidoesCongelamnetoModal}
                    >
                        OK
                    </Button>
                ]}
                key="modalViewCongelamentos"
            >
                <Row>
                    <Col span={24}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {
                            refLineTableClikedOpenModal.current?.status && refLineTableClikedOpenModal.current?.status != 'em_andamento' &&
                            <div
                                style={{
                                    marginBottom: 15
                                }}
                            >
                                <Button
                                    className="CertidoesCongelamento_BotaoVerde_edfrgjkfbrgqrepiujhnbw"
                                    type="primary"
                                    style={{ margin: 2 }}
                                    loading={loadingCertidoesCongelamnetoModal}
                                    onClick={() => handleClickDownloadAllFileZIP(refLineTableClikedOpenModal.current)}
                                >
                                    Baixar todos
                                </Button>
                            </div>
                        }
                    </Col>
                </Row>
                <Table
                    rowKey={(record) => record.id}
                    loading={loadingCertidoesCongelamnetoModal}
                    columns={columnsCertidoesCongelamnetoModal} dataSource={dadosTabelaStateCertidoesCongelamnetoModal}
                    scroll={{ x: 650 }}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltroCertidoesCongelamnetoModal.current = extra.currentDataSource
                        }
                    }
                    size="small"
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: false,
                        defaultPageSize: 100,
                        // position: ['topRight', 'bottomRight'],
                        position: [],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    locale={locale.Table}
                />
            </Modal>

            <Modal
                title="Certidões"
                visible={isCertidoesModalVisible}
                onOk={handleCloseCertidoesModal}
                onCancel={handleCloseCertidoesModal}
                style={{
                    top: 20
                }}
                className="modalDadasLimite_kaevdkfaed"
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleCloseCertidoesModal}
                    >
                        OK
                    </Button>,
                ]}
                key="modaldatalimitesnwwdgaiwsdfawi"
            >
                <img
                    style={{
                        width: '100%',
                    }}
                    src={CertidoesImg}
                />
            </Modal>
        </>
    );
}
